module.exports = __webpack_public_path__ + "img/gsxw_6.4d566dba.png";